import { combineReducers } from "redux";
import {
  getAccountInfoReducer,
  updateAccountInfoReducer,
} from "./API/accountInfoReducer";
import {
  addAddressReducer,
  deleteAddressReducer,
  editAddressReducer,
  getAddressReducer,
  setDefaultAddressReducer,
} from "./API/addressReducer";
import { forgotPasswordReducer, loginReducer, resetPasswordReducer, signupReducer } from "./API/auth";
import {
  addBankDetailReducer,
  bankDetailReducer,
  deleteBankDetailReducer,
  editBankDetailReducer,
} from "./API/bankDetailsReducer";
import { getBatchItems, updateBatchItems, createBatchItems, createSelectBatchItems } from "./API/batchItemsReducer";
import {
  addBlogReducer,
  blogsSearchReducer,
  deleteBlogReducer,
  editBlogReducer,
  getBlogByIdReducer,
  getBlogCategoriesReducer,
  getBlogsReducer,
} from "./API/blogs";

import {
  addBuyerSupplierReducer,
  bulkDeleteBuyerSupplierReducer,
  bulkUploadBuyerSupplierReducer,
  buyerSupplierReducer,
  deleteBuyerSupplierReducer,
  editBuyerSupplierReducer,
  getCompanyDetailsByGstnReducer,
} from "./API/buyerSupplier";
import {
  addCategoryReducer,
  deleteCategoryReducer,
  editCategoryReducer,
  getCategoryReducer,
} from "./API/categoryReducer";
import {
  addBlogCommentReducer,
  approveCommentsReducer,
  deleteBlogCommentReducer,
  getAllBlogsApprovedCommentsReducer,
  getApprovedBlogCommentsReducer,
  getBlogCommentstoBeApproveReducer,
} from "./API/commentReducer";
import { addContactUsReducer, getContactUsReducer } from "./API/contactUsReducer";
import {
  addCustomFieldsReducer,
  deleteCustomFieldsReducer,
  editCustomFieldReducer,
  editCustomFieldsReducer,
  editPermissionReducer,
  getCustomFieldsReducer,
} from "./API/customFields";
import {
  addCustomFormsReducer,
  deleteCustomFormsReducer,
  editCustomFormsReducer,
  getCustomFormsReducer,
} from "./API/customForms";
import { fastMovingSlowMovingItems, getCategoryWiseItems, getCompaniesCount, getDashboardData, getDocumentsCount, getInvoiceSummary, getItemsCount, getItemsSalesSummary, getItemsSalesSummaryWithPrediction, getPredictionValue, getSalesPrediction, getStoresCount, getStoreWiseItems, getUsersCount, onTimeDelayProduction, stockAgeing, stockLevelAnalysis, workOrderStatus, getSalesDashboardDetails } from "./API/dashboardReducer";
import { addDemoQueryDataReducer, getDemoQueryDataReducer } from "./API/demoQueryReducer";
import {
  createDocumentReducer,
  getApprovalHistoryReducer,
  changeApprovalStatusReducer,
  getDocumentsByStatusReducer,
  deleteDocumentReducer,
  discardDocumentReducer,
  editDocumentReducer,
  getDocumentByIdReducer,
  getDocumentItemsReducer,
  getDocumentsReducer,
  getSalesDocumentsItemsReducer,
  getServiceChallanItemsReducer,
  previewDocumentReducer,
  shortCloseTransactionReducer,
  getTableDocumentsReducer,
  createEInvoiceReducer,
  createEWayBillReducer,
  fetchCurrentDocReducer,
  emailDocumentReducer,
  cancelEInvoiceReducer,
  getChallanItemsReducer,
  createEWayBillFromEInvoiceReducer,
  cancelEWayBillReducer,
  saveRfqQuotationReducer,
} from "./API/documentReducer";
import {
  addDocumentSeriesReducer,
  deleteDocumentSeriesReducer,
  documentSeriesReducer,
  editDocumentSeriesReducer,
  setAsDefault,
  updateLastDocumentNumberReducer
} from "./API/documentSeriesReducer";
import { imageReducer } from "./API/imageUpload";
import { addInventoryServiceReducer, deleteInventoryServiceReducer, editInventoryServiceReducer, getInventoryServiceReducer } from "./API/inventoryServices";
import {
  addItemsReducer,
  bulkDeleteItemsReducer,
  bulkEditItemsReducer,
  bulkReconcilationItemsReducer,
  bulkStockUpdateReducer,
  bulkUploadAlternateUnitReducer,
  bulkUploadItemsReducer,
  deleteItemsReducer,
  editItemsReducer,
  itemsReducer,
  paginatedItemsReducer,
  getLastUpdatedPriceReducer,
} from "./API/items";
import {
  addLogisticDetailsReducer,
  deleteLogisticDetailsReducer,
  editLogisticDetailsReducer,
  getLogisticDetailsReducer,
} from "./API/logisticDetails";
import { addNewsLettersReducer, getNewsLettersReducer, unsubscribeNewsLetterReducer } from "./API/newsLettersReducer";
import {
  getNotificationsReducer,
  notifyReducer,
} from "./API/notificationReducer";
import {
  addPaymentTermReducer,
  deletePaymentTermReducer,
  editPaymentTermReducer,
  getPaymentTermReducer,
} from "./API/paymentTerm";
import { createProductionProcessReducer, deleteProductionProcessReducer, getProductionProcessByIdReducer, getProductionProcessReducer, updateProductionProcessReducer } from "./API/productionProcessReducer";
import { stockReconcileReducer } from "./API/reconcileAndUploadReducer";
import { reportColumnslPrefrenceReducer } from "./API/reportColumns";
import { getAllRejectStoreItemsReducer, stockTransferReducer } from "./API/stockTransferReducer";
import { stockUpdateReducer } from "./API/stockUpdateReducer";
import {
  addStoreReducer,
  deleteStoreReducer,
  editStoreReducer,
  getAllStockValuesReducer,
  getAllStoreItemsByStoresID,
  getAllStoresWithItemsReducer,
  getFifoPriceReducer,
  getStoreByIdReducer,
  getStoreByItem,
  getStoreByItemsReducer,
  getStoreReducer,
  setDefaultStoreReducer,
} from "./API/storeReducer";
import {
  addTeamsReducer,
  deleteTeamsReducer,
  editTeamsReducer,
  teamsReducer,
} from "./API/teams";
import {
  addTermsConditionReducer,
  deleteTermsConditionReducer,
  editTermsConditionReducer,
  getTermsConditionReducer,
} from "./API/termsCondition";
import {
  itemStockTransferHistoryReducer,
  stockTransferHistoryReducer,
} from "./API/transferHistoryReducer";
import {
  addTransporterDetailsReducer,
  deleteTransporterDetailsReducer,
  editTransporterDetailsReducer,
  getTransporterDetailsReducer,
} from "./API/transporterDetails";
import {
  addUOMReducer,
  deleteUOMReducer,
  editUOMReducer,
  getUOMReducer,
} from "./API/uomReducer";
import {
  addPackagingMasterReducer,
  deletePackagingMasterReducer,
  editPackagingMasterReducer,
  getPackagingMasterReducer,
} from "./API/packagingMasterReducer";
import {
  addItemMappingReducer,
  deleteItemMappingReducer,
  editItemMappingReducer,
  getItemMappingReducer,
} from "./API/itemMappingReducer";
import {
  addUserReducer,
  deleteCompaniesDataReducer,
  deleteUserReducer,
  editUserReducer,
  getCompaniesReducer,
  getPartialUserReducer,
  updateProfileLogoReducer,
  updateSignatureReducer,
  updateUserReducer,
  usersReducer,
} from "./API/users";
import appLocationReducer from "./appLocationReducer";
import createDocumentUIReducer from "./UI/createDocumentReducer";
import createBOMDetailsUIReducer from "./UI/ProductionSection/BillOfMaterial/createBOM";
import { bulkUploadBomReducer, createBOMDetailsReducer, deleteBillOfMaterialsReducer, deleteBOMDetailsReducer, duplicateBomReducer, editBillOfMaterialsReducer, getAllBOMDetailsReducer, getBOMDetailsByIdReducer, getBOMDetailsReducer, getItemsBomDetailsReducer, updateBOMDetailsReducer } from "./API/bomDetailsReducer";
import { createBOMProductionProcessReducer, deleteBOMProductionProcessReducer, getBOMProductionProcessReducer, updateBOMProductionProcessReducer } from "./API/bomProductionProcessReducer";
import { addBOMFinishedGoodsReducer, deleteBOMFinishedGoodsReducer, getBOMFinishedGoodsReducer, updateBOMFinishedGoodsReducer } from "./API/bomFinishedGoods";
import { addBOMRawMaterialsReducer, deleteBOMRawMaterialsReducer, getBOMRawMaterialsReducer, issueRawMaterialReducer, linkBomReducer, unlinkBomReducer, updateBOMRawMaterialsReducer } from "./API/bomRawMaterials";
import { addBOMScrapLogsReducer, deleteBOMScrapLogsReducer, getBOMScrapLogsReducer, updateBOMScrapLogsReducer } from "./API/bomScrapLogs";
import { addBOMAdditionalChargesReducer, deleteBOMAdditionalChargesReducer, getBOMAdditionalChargesReducer, updateBOMAdditionalChargesReducer } from "./API/bomAdditionalCharges";
import { bomBasedMaterialPlanningReducer, bulkIssueReducer, discardProductionReducer, getBulkProductionReducer, getBulkProductionsReducer, getProductionByIdReducer, getProductionsByCompanyIdReducer, getProductionsReducer, getRemainingProductionReducer, materialPlanningReducer, minStockMaterialPlanningReducer, productionBasedMaterialPlanningReducer, removeRowsReducer, returnRawMaterialReducer, saveFinishedGoodsReducer, saveReworkReducer, saveProductionReducer, startBulkProductionReducer, startProductionReducer, updateCostReducer, updateProcessReducer, updateProductionStatusReducer, updateScrapLogsStatusReducer, updateStartDateReducer, updateTableReducer, viewProductionHistoryReducer, getAllProductionsReducer, deleteLogsReducer } from "./API/production";
import { addBOMSeriesReducer, bomSeriesReducer, deleteBOMSeriesReducer, editBOMSeriesReducer, setDefaultBOMSeriesReducer, updateLastBOMNumberReducer } from "./API/bomSeries";
import { addLogPaymentsReducer, deleteLogPaymentsReducer, getLogPaymentByIdReducer, getLogPaymentsReducer, updateLogPaymentsReducer } from "./API/logPayments";
import { addLogTDSReducer, deleteLogTDSReducer, getLogTDSByIdReducer, getLogTDSReducer, updateLogTDSReducer } from "./API/logTDS";
import { addItemSeriesReducer, deleteItemSeriesReducer, editItemSeriesReducer, itemSeriesReducer, setDefaultItemSeriesReducer, updateLastItemNumberReducer } from "./API/itemSeries";
import { getReportsReducer } from "./API/reportsReducer";
import { getSettingReducer, updateSettingReducer } from "./API/settingReducer";
import { approveDocumentReducer, deleteApprovalPermissionReducer, getApprovalPermissionReducer, setApprovalPermissionReducer } from "./API/documentApprovalReducer";
import { acceptRejectApprovalReducer, getInventoryApprovalByIdReducer, getInventoryApprovalReducer } from "./API/inventoryApprovalReducer";
import {
  acceptRejectBOMApprovalReducer,
  deleteBOMApprovalPermissionReducer,
  getBOMApprovalByIdReducer,
  getBOMApprovalPermissionReducer,
  getBOMApprovalsReducer,
  setBOMApprovalPermissionReducer
} from "./API/bomApprovalReducer";
import { addLabelReducer, assignLabelsReducer, deleteLabelReducer, editLabelReducer, getLabelsReducer, removeLabelReducer } from "./API/labelReducer";
import { createEInvoiceCredentialReducer, deleteEInvoiceCredentialReducer, getEInvoiceCredentialReducer, updateEInvoiceCredentialReducer } from "./API/eInvoiceCredentialReducer";
import { discardProduction } from "../actions/API/production";
import { getPartialUser } from "../actions/API/users";
import { createEMailCredentialReducer, deleteEMailCredentialReducer, getEMailCredentialReducer, updateEMailCredentialReducer } from "./API/emailReducer";
import { amyCompletionsReducer, amyReportsReducer } from "./API/amyCompletionsReducer";
import { amyReports } from "../actions/API/amyCompletions";
import { addColumnReducer, deleteColumnReducer, editColumnReducer, getColumnsReducer } from "./API/showHideColumnReducer";
import { createGateEntryReducer, getAllGateEntriesReducer, getGateEntriesByIdReducer, updateGateEntryReducer } from "./API/gateEntry";
import { bulkUploadBom } from "../actions/API/bomDetails";
import { getServiceChallanItems } from "../actions/API/documents";

const UIReducers = combineReducers({
  appLocation: appLocationReducer,
  createDocumentUIData: createDocumentUIReducer,
  createBillOfMaterils: createBOMDetailsUIReducer,
});

const APIReducers = combineReducers({
  login: loginReducer,
  signup: signupReducer,
  forgotPassword: forgotPasswordReducer,
  resetPassword: resetPasswordReducer,

  addBlog: addBlogReducer,
  editBlog: editBlogReducer,
  deleteBlog: deleteBlogReducer,
  getBlogs: getBlogsReducer,
  getBlogById: getBlogByIdReducer,
  getBlogCategories: getBlogCategoriesReducer,

  imageUpload: imageReducer,

  addTeam: addTeamsReducer,
  getTeams: teamsReducer,
  editTeam: editTeamsReducer,
  deleteTeam: deleteTeamsReducer,

  addUOM: addUOMReducer,
  getUOM: getUOMReducer,
  editUOM: editUOMReducer,
  deleteUOM: deleteUOMReducer,

  addPackagingMaster: addPackagingMasterReducer,
  getPackagingMaster: getPackagingMasterReducer,
  editPackagingMaster: editPackagingMasterReducer,
  deletePackagingMaster: deletePackagingMasterReducer,

  addItemMapping: addItemMappingReducer,
  getItemMapping: getItemMappingReducer,
  editItemMapping: editItemMappingReducer,
  deleteItemMapping: deleteItemMappingReducer,

  addCategory: addCategoryReducer,
  getCategory: getCategoryReducer,
  editCategory: editCategoryReducer,
  deleteCategory: deleteCategoryReducer,

  addUser: addUserReducer,
  getUsers: usersReducer,
  editUser: editUserReducer,
  deleteUser: deleteUserReducer,
  updateUser: updateUserReducer,
  updateProfileLogo: updateProfileLogoReducer,
  updateSignature: updateSignatureReducer,
  getPartialUser: getPartialUserReducer,
  getCompanies: getCompaniesReducer,
  deleteCompaniesData: deleteCompaniesDataReducer,

  addItems: addItemsReducer,
  getItems: itemsReducer,
  getPaginatedItems: paginatedItemsReducer,
  editItems: editItemsReducer,
  deleteItems: deleteItemsReducer,
  bulkDeleteItems: bulkDeleteItemsReducer,
  bulkUploadItems: bulkUploadItemsReducer,
  bulkEditItems: bulkEditItemsReducer,
  bulkReconcilationItems: bulkReconcilationItemsReducer,
  bulkUploadAlternateUnits: bulkUploadAlternateUnitReducer,
  getLastUpdatedPrice: getLastUpdatedPriceReducer,

  addBuyerSupplier: addBuyerSupplierReducer,
  getBuyerSupplier: buyerSupplierReducer,
  deleteBuyerSupplier: deleteBuyerSupplierReducer,
  bulkDeleteBuyerSupplier: bulkDeleteBuyerSupplierReducer,
  editBuyerSupplier: editBuyerSupplierReducer,
  bulkUploadBuyerSupplier: bulkUploadBuyerSupplierReducer,
  getCompanyDetailsByGstn: getCompanyDetailsByGstnReducer,

  addStore: addStoreReducer,
  getStore: getStoreReducer,
  getStoreById: getStoreByIdReducer,
  getStoreByItems: getStoreByItemsReducer,
  editStore: editStoreReducer,
  deleteStore: deleteStoreReducer,
  getAllStockValues: getAllStockValuesReducer,
  getStoreByItem: getStoreByItem,
  getAllStoreItemsByStoresID: getAllStoreItemsByStoresID,
  setDefaultStore: setDefaultStoreReducer,

  addAddress: addAddressReducer,
  getAddress: getAddressReducer,
  editAddress: editAddressReducer,
  deleteAddress: deleteAddressReducer,
  setDefaultAddress: setDefaultAddressReducer,

  addBlogComment: addBlogCommentReducer,
  deleteBlogComment: deleteBlogCommentReducer,
  approveComments: approveCommentsReducer,
  getApprovedBlogComments: getApprovedBlogCommentsReducer,
  getBlogCommentstoBeApprove: getBlogCommentstoBeApproveReducer,
  getAllBlogsApprovedComments: getAllBlogsApprovedCommentsReducer,
  blogSearch: blogsSearchReducer,

  addBOMSeries: addBOMSeriesReducer,
  bomSeries: bomSeriesReducer,
  editBOMSeries: editBOMSeriesReducer,
  deleteBOMSeries: deleteBOMSeriesReducer,
  updateLastBOMNumber: updateLastBOMNumberReducer,
  setDefaultBOMSeries: setDefaultBOMSeriesReducer,

  addItemSeries: addItemSeriesReducer,
  itemSeries: itemSeriesReducer,
  editItemSeries: editItemSeriesReducer,
  deleteItemSeries: deleteItemSeriesReducer,
  updateLastItemNumber: updateLastItemNumberReducer,
  setDefaultItemSeries: setDefaultItemSeriesReducer,

  addDocumentSeries: addDocumentSeriesReducer,
  getDocumentSeries: documentSeriesReducer,
  editDocumentSeries: editDocumentSeriesReducer,
  deleteDocumentSeries: deleteDocumentSeriesReducer,
  updateLastDocumentNumber: updateLastDocumentNumberReducer,
  setAsDefault: setAsDefault,

  getDocuments: getDocumentsReducer,
  getDocumentById: getDocumentByIdReducer,
  createDocument: createDocumentReducer,
  getDocumentsByStatus: getDocumentsByStatusReducer,
  createEInvoice: createEInvoiceReducer,
  createEWayBill: createEWayBillReducer,
  fetchCurrentDoc: fetchCurrentDocReducer,
  emailDocument: emailDocumentReducer,
  cancelEInvoice: cancelEInvoiceReducer,
  createEWayBillFromEInvoice: createEWayBillFromEInvoiceReducer,
  cancelEWayBill: cancelEWayBillReducer,


  getApprovalHistory: getApprovalHistoryReducer,
  changeApprovalStatus: changeApprovalStatusReducer,

  editDocument: editDocumentReducer,
  saveRfqQuotation: saveRfqQuotationReducer,
  discardDocument: discardDocumentReducer,
  deleteDocument: deleteDocumentReducer,
  previewDocument: previewDocumentReducer,
  getDocumentItems: getDocumentItemsReducer,
  shortCloseTransaction: shortCloseTransactionReducer,
  getSalesDocumentsItems: getSalesDocumentsItemsReducer,
  getChallanItems: getChallanItemsReducer,

  addBankDetail: addBankDetailReducer,
  deleteBankDetail: deleteBankDetailReducer,
  editBankDetail: editBankDetailReducer,
  getBankDetail: bankDetailReducer,

  notify: notifyReducer,
  getNotifications: getNotificationsReducer,

  getAccountInfo: getAccountInfoReducer,
  updateAccountInfo: updateAccountInfoReducer,

  stockTransfer: stockTransferReducer,
  stockUpdate: stockUpdateReducer,
  itemStockTransferHistory: itemStockTransferHistoryReducer,
  stockTransferHistory: stockTransferHistoryReducer,
  getAllRejectStoreItems: getAllRejectStoreItemsReducer,

  stockReconcile: stockReconcileReducer,

  addPaymentTerm: addPaymentTermReducer,
  getPaymentTerm: getPaymentTermReducer,
  editPaymentTerm: editPaymentTermReducer,
  deletePaymentTerm: deletePaymentTermReducer,

  addLogisticDetails: addLogisticDetailsReducer,
  getLogisticDetails: getLogisticDetailsReducer,
  editLogisticDetails: editLogisticDetailsReducer,
  deleteLogisticDetails: deleteLogisticDetailsReducer,

  addTransporterDetails: addTransporterDetailsReducer,
  getTransporterDetails: getTransporterDetailsReducer,
  editTransporterDetails: editTransporterDetailsReducer,
  deleteTransporterDetails: deleteTransporterDetailsReducer,

  addTermsCondition: addTermsConditionReducer,
  getTermsCondition: getTermsConditionReducer,
  editTermsCondition: editTermsConditionReducer,
  deleteTermsCondition: deleteTermsConditionReducer,

  addCustomFields: addCustomFieldsReducer,
  getCustomFields: getCustomFieldsReducer,
  editCustomFields: editCustomFieldsReducer,
  deleteCustomFields: deleteCustomFieldsReducer,
  editPermission: editPermissionReducer,
  editCustomField: editCustomFieldReducer,

  addCustomForms: addCustomFormsReducer,
  getCustomForms: getCustomFormsReducer,
  editCustomForms: editCustomFormsReducer,
  deleteCustomForms: deleteCustomFormsReducer,

  addContactUs: addContactUsReducer,
  getContactUs: getContactUsReducer,

  addDemoQueryData: addDemoQueryDataReducer,
  getDemoQueryData: getDemoQueryDataReducer,

  addNewsLetters: addNewsLettersReducer,
  getNewsLetters: getNewsLettersReducer,
  unSubscribeNewsLetter: unsubscribeNewsLetterReducer,

  reportColumnslPrefrence: reportColumnslPrefrenceReducer,

  createProductionProcess: createProductionProcessReducer,
  getProductionProcess: getProductionProcessReducer,
  getProductionProcessById: getProductionProcessByIdReducer,
  updateProductionProcess: updateProductionProcessReducer,
  deleteProductionProcess: deleteProductionProcessReducer,
  getAllProductions: getAllProductionsReducer,
  deleteLogs: deleteLogsReducer,

  getBOMDetails: getBOMDetailsReducer,
  getBOMDetailsById: getBOMDetailsByIdReducer,
  getAllBOMDetails: getAllBOMDetailsReducer,
  createBOMDetails: createBOMDetailsReducer,
  updateBOMDetails: updateBOMDetailsReducer,
  deleteBOMDetails: deleteBOMDetailsReducer,
  deleteBillOfMaterials: deleteBillOfMaterialsReducer,
  editBillOfMaterials: editBillOfMaterialsReducer,
  getItemsBOMDetails: getItemsBomDetailsReducer,
  duplicateBom: duplicateBomReducer,
  bulkUploadBom: bulkUploadBomReducer,

  createBOMProductionProcess: createBOMProductionProcessReducer,
  getBOMProductionProcess: getBOMProductionProcessReducer,
  updateBOMProductionProcess: updateBOMProductionProcessReducer,
  deleteBOMProductionProcess: deleteBOMProductionProcessReducer,

  getItemsCount: getItemsCount,
  getStoresCount: getStoresCount,
  getUsersCount: getUsersCount,
  getDocumentsCount: getDocumentsCount,
  getCompaniesCount: getCompaniesCount,
  getItemsSalesSummary: getItemsSalesSummary,
  getInvoiceSummary: getInvoiceSummary,
  getPredictionValue: getPredictionValue,
  getSalesPrediction: getSalesPrediction,
  getItemsSalesSummaryWithPrediction: getItemsSalesSummaryWithPrediction,
  getDashboardData: getDashboardData,

  getStoreWiseItems: getStoreWiseItems,
  getCategoryWiseItems: getCategoryWiseItems,
  fastMovingSlowMovingItems: fastMovingSlowMovingItems,
  stockLevelAnalysis: stockLevelAnalysis,
  stockAgeing: stockAgeing,
  getWorkOrderStatus: workOrderStatus,
  getOnTimeDelayProduction: onTimeDelayProduction,
  getSalesDashboardDetails: getSalesDashboardDetails,
  getBatchItems: getBatchItems,
  updateBatchItems: updateBatchItems,
  createBatchItems: createBatchItems,
  createSelectBatchItems: createSelectBatchItems,

  addInventoryService: addInventoryServiceReducer,
  getInventoryService: getInventoryServiceReducer,
  editInventoryService: editInventoryServiceReducer,
  deleteInventoryService: deleteInventoryServiceReducer,

  addBOMFinishedGoods: addBOMFinishedGoodsReducer,
  getBOMFinishedGoods: getBOMFinishedGoodsReducer,
  updateBOMFinishedGoods: updateBOMFinishedGoodsReducer,
  deleteBOMFinishedGoods: deleteBOMFinishedGoodsReducer,

  addBOMRawMaterials: addBOMRawMaterialsReducer,
  getBOMRawMaterials: getBOMRawMaterialsReducer,
  updateBOMRawMaterials: updateBOMRawMaterialsReducer,
  deleteBOMRawMaterials: deleteBOMRawMaterialsReducer,
  issueRawMaterial: issueRawMaterialReducer,

  addBOMScrapLogs: addBOMScrapLogsReducer,
  getBOMScrapLogs: getBOMScrapLogsReducer,
  updateBOMScrapLogs: updateBOMScrapLogsReducer,
  deleteBOMScrapLogs: deleteBOMScrapLogsReducer,

  addBOMAdditionalCharges: addBOMAdditionalChargesReducer,
  getBOMAdditionalCharges: getBOMAdditionalChargesReducer,
  updateBOMAdditionalCharges: updateBOMAdditionalChargesReducer,
  deleteBOMAdditionalCharges: deleteBOMAdditionalChargesReducer,

  addLogPayments: addLogPaymentsReducer,
  getLogPayments: getLogPaymentsReducer,
  getlogPaymentById: getLogPaymentByIdReducer,
  updateLogPayments: updateLogPaymentsReducer,
  deleteLogPayments: deleteLogPaymentsReducer,

  addLogTDS: addLogTDSReducer,
  getLogTDS: getLogTDSReducer,
  getlogTDSById: getLogTDSByIdReducer,
  updateLogTDS: updateLogTDSReducer,
  deleteLogTDS: deleteLogTDSReducer,

  startProduction: startProductionReducer,
  getProductions: getProductionsReducer,
  getProductionById: getProductionByIdReducer,
  getBulkProduction: getBulkProductionReducer,
  getRemainingProduction: getRemainingProductionReducer,
  getAllStoresWithItems: getAllStoresWithItemsReducer,
  updateProcess: updateProcessReducer,
  updateCost: updateCostReducer,
  saveFinishedGoods: saveFinishedGoodsReducer,
  saveRework: saveReworkReducer,
  updateProductionStatus: updateProductionStatusReducer,
  updateScrapLogs: updateScrapLogsStatusReducer,
  saveProduction: saveProductionReducer,
  materialPlanning: materialPlanningReducer,
  minStockMaterialPlanning: minStockMaterialPlanningReducer,
  bomBasedMaterialPlanning: bomBasedMaterialPlanningReducer,
  getProductionsByCompanyId: getProductionsByCompanyIdReducer,
  productionBasedMaterialPlanning: productionBasedMaterialPlanningReducer,
  updateTable: updateTableReducer,
  linkBom: linkBomReducer,
  unlinkBom: unlinkBomReducer,
  removeRows: removeRowsReducer,
  returnRawMaterial: returnRawMaterialReducer,
  startBulkProduction: startBulkProductionReducer,
  getBulkProductions: getBulkProductionsReducer,
  discardProduction: discardProductionReducer,
  bulkIssue: bulkIssueReducer,
  updateStartDate: updateStartDateReducer,

  getReports: getReportsReducer,

  updateSetting: updateSettingReducer,
  getSetting: getSettingReducer,
  bulkStockUpdate: bulkStockUpdateReducer,
  getServiceChallanItems: getServiceChallanItemsReducer,

  getFifoPrice: getFifoPriceReducer,

  setApprovalPermission: setApprovalPermissionReducer,
  deleteApprovalPermission: deleteApprovalPermissionReducer,
  getApprovalPermission: getApprovalPermissionReducer,
  approveDocument: approveDocumentReducer,
  getTableDocuments: getTableDocumentsReducer,

  getInventoryApprovals: getInventoryApprovalReducer,
  getInventoryApprovalById: getInventoryApprovalByIdReducer,
  acceptRejectApproval: acceptRejectApprovalReducer,

  getBOMApprovals: getBOMApprovalsReducer,
  getBOMApprovalById: getBOMApprovalByIdReducer,
  acceptRejectBOMApproval: acceptRejectBOMApprovalReducer,
  getBOMApprovalPermission: getBOMApprovalPermissionReducer,
  setBOMApprovalPermission: setBOMApprovalPermissionReducer,
  deleteBOMApprovalPermission: deleteBOMApprovalPermissionReducer,

  viewProductionHistory: viewProductionHistoryReducer,
  getLabels: getLabelsReducer,
  addLabel: addLabelReducer,
  editLabel: editLabelReducer,
  deleteLabel: deleteLabelReducer,
  assignLabels: assignLabelsReducer,
  removeLabel: removeLabelReducer,

  createEInvoiceCredential: createEInvoiceCredentialReducer,
  getEInvoiceCredential: getEInvoiceCredentialReducer,
  updateEInvoiceCredential: updateEInvoiceCredentialReducer,
  deleteEInvoiceCredential: deleteEInvoiceCredentialReducer,

  createEmailCredential: createEMailCredentialReducer,
  getEmailCredential: getEMailCredentialReducer,
  updateEmailCredential: updateEMailCredentialReducer,
  deleteEmailCredential: deleteEMailCredentialReducer,
  // AMY AI Reducer
  amyCompletions: amyCompletionsReducer,
  amyReports: amyReportsReducer,

  getColumns: getColumnsReducer,
  addColumns: addColumnReducer,
  editColumns: editColumnReducer,
  deleteColumns: deleteColumnReducer,

  getGateEntryByID: getGateEntriesByIdReducer,
  getAllGateEntries: getAllGateEntriesReducer,
  updateGateEntry: updateGateEntryReducer,
  createGateEntry: createGateEntryReducer,
  
});

const RootReducer = combineReducers({
  api: APIReducers,
  ui: UIReducers,
});

export default RootReducer;
